import { useMemo } from 'react';
import { useGetMany, useRecordContext, useTranslate } from 'react-admin';
import { Box } from '@mui/material';
import { getModelDisplayName, getModelTooltipName, getParameterModelIds } from '@/helpers/parameter/parameterRecord.js';
import { ParameterChip } from '@/components/parameter/ParameterChip.jsx';

export const ParameterModelsField = () => {
    const record = useRecordContext();
    const translate = useTranslate();
    const modelIds = getParameterModelIds(record);
    const { data: modelRecords = [] } = useGetMany('device-model', { ids: modelIds }, { enabled: modelIds.length > 0 });

    const modelsById = useMemo(() => {
        const byId = new Map();
        modelRecords.forEach(model => {
            if (model?.id != null) {
                byId.set(String(model.id), model);
            }
        });
        return byId;
    }, [modelRecords]);

    if (!modelIds.length) {
        return translate('resources.parameter.labels.allModels');
    }

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
            {modelIds.map((id, index) => {
                const model = modelsById.get(String(id));
                const label = getModelDisplayName(model);
                if (!label) {
                    return null;
                }

                return <ParameterChip key={`${id}-${index}`} label={label} tooltip={getModelTooltipName(model)} />;
            })}
        </Box>
    );
};
